import moment from 'moment'
import _ from 'lodash'

function getFirstNonWorkingDay(startTime, nonWorkingHours) {
  return moment(_.cloneDeep(startTime)).subtract(7, 'days').day(nonWorkingHours.startDay).startOf('day').valueOf()
}

function getLastNonWorkingDay(endTime, nonWorkingHours) {
  return moment(_.cloneDeep(endTime)).day(nonWorkingHours.startDay).startOf('day').valueOf()
}

export function getNonWorkingHoursTimeFrames(startTime, endTime, nonWorkingHours) {
  // Copy the start and end time
  const firstNonWorkingDay = moment(getFirstNonWorkingDay(startTime, nonWorkingHours))
  const lastNonWorkingDay = moment(getLastNonWorkingDay(endTime, nonWorkingHours))

  // find the day difference between the dates
  const totalAmountOfDaysBetweenStartAndEndTime = moment(lastNonWorkingDay).diff(firstNonWorkingDay, 'days')

  // Find all days in month that match the given nonWorkingHours startDay
  const nonWorkingHourTimeframes = []
  for (let currentDay = 0; currentDay <= totalAmountOfDaysBetweenStartAndEndTime; currentDay += 7) {
    const nonWorkingHoursStartDay = _.cloneDeep(firstNonWorkingDay)
      .add(currentDay, 'days')
      .add(nonWorkingHours.hour, 'hours')
      .add(nonWorkingHours.minutes, 'minutes')

    // startTime of non working hours is startDay (day at 00:00) + startTime on that day, all in milliseconds
    const startTime = nonWorkingHoursStartDay.valueOf()
    const endTime = startTime + nonWorkingHours.duration

    nonWorkingHourTimeframes.push({ startTime, endTime })
  }

  return nonWorkingHourTimeframes
}

export function calculateExtraNonWorkingTime(rtf, startTime, endTime) {
  // Overlapping visit
  if (rtf.startTime >= startTime && endTime >= rtf.endTime) {
    return rtf.endTime - rtf.startTime
  }

  // Non working hours start before the terminal visit
  if (startTime >= rtf.startTime && endTime >= rtf.endTime) {
    return rtf.endTime - startTime
  }

  // Non working hours start during the terminal visit but end afterwards
  if (rtf.startTime >= startTime && rtf.endTime >= endTime) {
    return rtf.endTime - rtf.startTime
  }

  // If the non working hours completely overlap the terminal visit
  if (startTime >= rtf.startTime && rtf.endTime >= endTime) {
    return rtf.endTime - startTime
  }

  // Should not happen
  return 0
}

export function moveTimeIfInNonWorkingTime(time, nonWorkingHours) {
  const nonWorkingHourTimeframes = nonWorkingHours.map(nwh => getNonWorkingHoursTimeFrames(time, time, nwh))

  let result = 0

  // Check which non working hour timeframes are actually during the terminal visit
  nonWorkingHourTimeframes.forEach(timeFramePerNonWorkingHours => {
    const relevantTimeFrames = timeFramePerNonWorkingHours.filter(
      tfpnwh => tfpnwh.endTime > time && time >= tfpnwh.startTime
    )

    // Check how much time needs to be added
    relevantTimeFrames.forEach(rtf => (result += rtf.endTime - rtf.startTime))
  })

  return result
}
